<template>
  <div id="app">
    <navigation class="app-header"/>
    <div class="app-content" id="appContent">
      <router-view class="router-view" />
      <conductor class="app-content-footer"/>
    </div>
  </div>
</template>
<script>
import navigation from "./components/navigation";
import conductor from "./components/conductor";
export default {
  components: { navigation, conductor },
  watch:{
    $route:{
      handler(val){
        document.getElementById('appContent').scrollTo(0, 0)
      }
    }
  },
  mounted(){
    
  }
};
</script>
<style lang="scss">
#app {
  width: 100%;
  height: 100vh;
  font-size:0.14rem;
  font-family: pfmedimfont;
  background: #fff;
  .app-header{
    width:100%;
    height:0.72rem;
  }
  .app-content{
    width:100%;
    height:calc(100% - 0.72rem);
    overflow-y: scroll;
    &-footer{
      width:100%;
      height:5.25rem;
      background: #3c3c3c;
    }
  }
  ::-webkit-scrollbar{
    display: none;
  }
}
</style>
